import { Store } from 'redux';
import { loadTranslations, setLocale, syncTranslationWithStore } from 'react-redux-i18n';

export enum Locales {
	fr_FR = 'FR',
	en_UK = 'UK',
	es_ES = 'ES',
	ca_ES = 'CA',
	de_DE = 'DE',
	pt_PT = 'PT',
	it_IT = 'IT',
}

const DEFAULT_LOCALE = 'fr_FR';
const locales = {
	en_UK: require('../translations/en_UK.json'),
	es_ES: require('../translations/es_ES.json'),
	ca_ES: require('../translations/ca_ES.json'),
	fr_FR: require('../translations/fr_FR.json'),
	de_DE: require('../translations/de_DE.json'),
	pt_PT: require('../translations/pt_PT.json'),
	it_IT: require('../translations/it_IT.json'),
};

const getResolvedLocale = (requestedLocale: string): string => {
	const availableLocales = Object.keys(locales);
	if (availableLocales.includes(requestedLocale)) {
		// returns the exact locale if available
		return requestedLocale;
	}

	const localeRegex = /^([a-z][a-z])_([A-Z][A-Z])$/;
	const regexMatch = localeRegex.exec(requestedLocale);

	if (!!regexMatch && !!regexMatch[1]) {
		const requestedLanguage = regexMatch[1];
		const requestedLanguageIndex = availableLocales.indexOf(requestedLanguage);
		if (requestedLanguageIndex >= 0) {
			// returns the requested language
			return availableLocales[requestedLanguageIndex];
		}

		for (let i = 0; i < availableLocales.length; i++) {
			const availableLocale = availableLocales[i];
			const regexMatch = localeRegex.exec(availableLocale);
			if (!!regexMatch && !!regexMatch[1]) {
				const availableLanguage = regexMatch[1];

				if (availableLanguage === requestedLanguage) {
					// returns a locale with the requested language
					return availableLocale;
				}
			}
		}
	}

	return DEFAULT_LOCALE;
};

export default (store: Store<{}>, locale: string = DEFAULT_LOCALE) => {
	const resolvedLocale = getResolvedLocale(locale);
	syncTranslationWithStore(store);
	store.dispatch(loadTranslations(locales));
	store.dispatch(setLocale(resolvedLocale));
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/store/setLocales.ts